import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { updateNotification, deleteNotification, fetchNotifications } from '../../store/actions/notificationActions';
import { firestore } from '../../config/firebase';
import { FiCheckCircle, FiXSquare } from 'react-icons/fi';
import Pagination from 'rc-pagination';
import 'rc-pagination/assets/index.css';
import './Notifications.css';

const lang = {
    en: {
        status: 'Status',
        date: 'Date',
        msg: 'Message',
        read: 'Read',
        products: 'Products',
        alert: {
            due: { start: 's payment is due on', middle: 'Check the', last: 'sale.' },
            link: 'Hey friendly reminder. It is time to count the items in the storage.',
            items: { start: 'There are only', middle: 'items left. Bring more', last: 'products.' },
        }
    },
    uz: {
        status: 'Holati',
        date: 'Sana',
        msg: "Xabar",
        read: "O'qing",
        products: 'Mahsulotlar',
        alert: {
            due: { start: "ning to'lovi", middle: "da. To'liq ma'lumot", last: 'buyerda.' },
            link: "Do'stona eslatma. Ombordagi mahsulotlarni hisoblash vaqti keldi.",
            items: { start: 'Omborda', middle: "mahsulotlar qoldi. Omborga quydagi mahsulotdan olib keling:", last: 'mahsulot' },
        }
    },
    ru: {
        status: 'Статус',
        date: 'Дата',
        msg: 'Сообщение',
        read: 'Читать',
        products: 'Товары',
        alert: {
            due: { start: ' должен оплатить', middle: '. Проверить', last: 'продажа.' },
            link: 'Привет дружеское напоминание. Пришло время подсчитать предметы в склад.',
            items: { start: 'Есть только', middle: ' в склад. Принести больше', last: 'товары.' },
        }
    }
}

class Notifications extends Component {
    state = { notifications: [], category: '', totalItems: 0, currentData: [], pageSize: 10 }
    componentDidMount() {
        this.setState({
            totalItems: this.props.notifications.length,
            currentData: this.props.notifications.slice(0, this.state.pageSize),
            display: 'none'
        });

        if (this.props.user.id) {
            firestore.collection("users").doc(this.props.user.id)
                .collection('notifications')
                .onSnapshot((doc) => {
                    let notifications = [];
                    doc.forEach(item => notifications.push({ ...item.data(), id: item.id }))
                    this.props.fetchNotifications(notifications);
                });
        } else {
            firestore.collection("users").doc(this.props.user.uid)
                .collection('notifications')
                .onSnapshot((doc) => {
                    let notifications = [];
                    doc.forEach(item => notifications.push({ ...item.data(), id: item.id }))
                    this.props.fetchNotifications(notifications);
                });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.notifications.length !== prevProps.notifications.length) {
            this.forceUpdate();
            this.setState({
                totalItems: this.props.notifications.length,
                currentData: this.props.notifications.slice(0, this.state.pageSize),
            });
        }
    }

    pageHandler = (page) => {
        const startPosition = this.state.pageSize * page - this.state.pageSize;
        const endPosition = this.state.pageSize * page <= this.state.totalItems ? (this.state.pageSize * page) : this.state.totalItems;
        let data = this.props.notifications.slice(startPosition, endPosition)


        this.setState({
            currentData: data
        })
    }

    // Check message after it has been read
    activeStateHandler = (id) => {
        const currentNotification = this.state.currentData.find(item => {
            if (item.id === id) {
                item.active = false;
                return item
            }
        });
        this.setState({ notifications: [...this.state.currentData, currentNotification] })
        return firestore
            .doc('users/' + this.props.user.id + '/notifications/' + id)
            .update({ active: false })
            .then(() => this.props.updateNotification(id))

    }

    // Delete the message
    messageHandler = id => {
        this[id + 'Ref'].classList.add('remove-me');
        setTimeout(() => {
            this.setState(prevState => {
                return { notifications: prevState.currentData.filter(i => i.id !== id) }
            });
            return firestore
                .doc('users/' + this.props.user.id + '/notifications/' + id)
                .delete()
                .then(() => this.props.deleteNotification(id))

        }, 500)

    }

    render() {
        const { status, date, msg, alert: { due, items }, read } = lang[this.props.user.lang || 'uz'];
        return (
            <div id="notifications-page">
                <table className="table table-striped">
                    <thead className="thead-dark">
                        <tr>
                            <th scope="col">{status}</th>
                            <th scope="col">{date}</th>
                            <th scope="col">{msg}</th>
                            <th scope="col">:</th>
                        </tr>
                    </thead>
                    <tbody className="font-14">
                        {
                            this.state.currentData.map((item, index) => {
                                let link = '';
                                if (item.type === 'debt') {
                                    link = <td>{item.name || 'Customer'}{due.start} {new Date(item.dueDate).toLocaleDateString()}{due.middle} <Link to={`/sales/${item.saleId}`}>{due.last}</Link></td>
                                } else if (item.type === 'count') {
                                    link = <td>{link}</td>
                                } else {
                                    link = <td>{items.start} {item.piece} {items.middle} <Link to={`/products/${item.productId}`}>{items.last}</Link>.</td>
                                }
                                return (
                                    <tr key={item.id || index} ref={(ref) => this[item.id + 'Ref'] = ref}>
                                        <th scope="row">
                                            <span
                                                onClick={(id) => this.activeStateHandler(item.id)}
                                                className={`text-${item.active ? 'primary' : 'success'}`}
                                            >{!item.active ? <FiCheckCircle /> : <button className="btn btn-sm btn-primary">{read}</button>}</span>
                                        </th>
                                        <td>{new Date(item.createdAt).toLocaleString()}</td>
                                        {link}
                                        <td>
                                            <span
                                                onClick={(id) => this.messageHandler(item.id)}
                                                className="text-danger font-18 hover"
                                            ><FiXSquare /></span>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
                <Pagination
                    showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
                    total={this.state.totalItems}
                    pageSize={this.state.pageSize}
                    onChange={(page) => this.pageHandler(page)}
                    hideOnSinglePage={true}
                />
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        notifications: state.notifications.notifications.sort((a, b) => b.createdAt - a.createdAt),
        user: state.user
    }
}

const mapDispatchToProps = dispatch => {
    return {
        updateNotification: (data) => dispatch(updateNotification(data)),
        deleteNotification: (data) => dispatch(deleteNotification(data)),
        fetchNotifications: (data) => dispatch(fetchNotifications(data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);
